import script from "./material-shape-container.vue?vue&type=script&setup=true&lang=ts"
export * from "./material-shape-container.vue?vue&type=script&setup=true&lang=ts"

import "./material-shape-container.vue?vue&type=style&index=0&id=250aaa25&lang=scss&scoped=true"

import exportComponent from "/builds/snedson/snotra-backend/snotra-front-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-250aaa25"]])

export default __exports__